<template>
  <div>
    <v-toolbar flat color="white" class="pt-3">
      <h2
       class="title grey--text font-weight-bold"
      >Inventory Warehouse: {{stockWarehouseInfo.name}}</h2>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('passive')">
      <passiveinventory
    :passiveinventory="passiveInventory"
    :stocktypes="stockTypes"
    :key="key1"
    ></passiveinventory>
    </div>

    <div v-if="displayContents('active')">
     <activeinventory
    :activeinventory="activeInventory"
    :allactiveinventory="allActiveInventory"
    :devicemakemodels="deviceMakeModels"
    :tableloading="tableLoading"
    :key="key"
    ></activeinventory>
    </div>
   </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import PassiveInventory from "@/components/PassiveInventory.vue";
import ActiveInventory from "@/components/ActiveInventory.vue";
export default {
    components: {
    passiveinventory: PassiveInventory,
    activeinventory: ActiveInventory
  },
    data(){
        return {
        activeInventory: [],
        allActiveInventory: [],
        deviceMakeModels: [],
        tableLoading: true,
        key1: 0,
        key:0,
        activeTabName: "",
        passiveInventory: [],
        stockWarehouseInfo: [],
        stockTypes: [],
        key: 0,
       tabs: [
        { name: "passive", displayName: "Passive Inventory" },
        { name: "active", displayName: "Active Inventory" }
      ]
            }
    },
    created(){
        this.setActiveTabName('passive')
        this.initialize()
    },
    methods: {
    initialize() {
        this.getPassiveInventory()
        this.getStockWarehouse() 
        this.getStockTypes()
        this.getActiveInventory()
        this.getDeviceMakeModels()  
    },
    getStockWarehouse(){
      Api()
      .get('/stockWarehouse/'+ this.$route.params.inventoryWarehouseId )
      .then(response=>{
        this.stockWarehouseInfo=response.data
      })
    },
    getStockTypes(){
      Api()
      .get('/stockType')
      .then(response=>{
        this.stockTypes=response.data
      })
    },
    getPassiveInventory(){
        Api()
        .get("/passiveEquipment/byStockWarehouse/" + this.$route.params.inventoryWarehouseId )
        .then(async response => {
          this.passiveInventory = response.data;     
          this.key1+=1
        });
    },
    getActiveInventory(){
        Api()
        .get("/devices/inventoryWarehouse/" + this.$route.params.inventoryWarehouseId)
        .then(response => {
          this.allActiveInventory = response.data;
          var helper = {};
            var result = response.data.reduce(function(r, o) {
              var key = o.deviceMakeModelId;
              if(!helper[key]) {
                helper[key] = Object.assign({}, o);
                if(o.isActive&&!o.isDeleted){
                  helper[key].count=1
                  if(!o.inStock){
                    helper[key].activeCount=1
                    helper[key].stockCount=0
                  } else {
                    helper[key].activeCount=0
                    helper[key].stockCount=1
                  }
                  r.push(helper[key]);
                }
                
              } else {
                if(o.isActive&&!o.isDeleted){
                  helper[key].count+=1
                  if(!o.inStock){
                    helper[key].activeCount+=1
                  } else {
                    helper[key].stockCount+=1
                  }
                }
              }
              return r;
            }, []);
            this.activeInventory=result
            this.tableLoading=false
            this.key+=1
        });
    },
    getDeviceMakeModels(){
      Api()
      .get('/deviceMakeModels')
      .then(response=>{
        this.deviceMakeModels=response.data
      })
    },
     displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    }     
}
</script>
